<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:15:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>分账角色管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加角色</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="code" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="name" label="角色名称" align="center">
          </el-table-column>
          <el-table-column label="角色类型" align="center" prop="propValue">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.type === 1">公司</span>
                <span v-else>个人</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          :current-page="page"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item
          label="角色类型"
          prop="status"
          style="display: flex; align-items: center"
        >
          <el-radio-group v-model="ruleForm1.status">
            <el-radio :label="1">公司</el-radio>
            <el-radio :label="2">个人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="角色名称" prop="name">
          <el-input
            v-model="ruleForm1.name"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "",
      editId: "",
      ruleForm1: {
        status: "",
        name: "",
      },
      rules: {
        name: [{ required: true, message: "必选项", trigger: "blur" }],
        status: [{ required: true, message: "必选项", trigger: "change" }],
      },
      selectData: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            name: this.ruleForm1.name,
            type: this.ruleForm1.status,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/profitShare/role/save`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.selectData = {};
                this.ruleForm1.status = "";
                this.ruleForm1.name = "";
              });
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/profitShare/role/edit`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.selectData = {};
                this.ruleForm1.status = "";
                this.ruleForm1.name = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    add() {
      this.title = "新增角色";
      this.dialogFormVisible = true;
      this.editId = "";
      this.ruleForm1.name = "";
      this.ruleForm1.status = "";
    },
    handleEdit(val) {
      this.selectData = val;
      this.editId = val.id;
      this.title = "编辑角色";
      this.ruleForm1.name = val.name;
      this.ruleForm1.status = val.type;
      this.dialogFormVisible = true;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$axios
        .post(`/admapi/profitShare/role/list`, params)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/profitShare/role/delete/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.page = 1;
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
